export default __webpack_public_path__ + "static/media/tooltip.0f6b498d.svg";